import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { useProps } from './useHooks.mjs';
import { SubTitle, LeftWrapper, RightWrapper, AppBarWrapper, CenterWrapper, TitleContainer, MainTitle, stickyWrapperStyle, StickyWrapper, Wrapper, ScrollParallaxWrapper } from './styledComponent.mjs';
import { DisplayControllerAboutScrollDirection } from '../displayControllerAboutScrollDirection/index.mjs';

var AppBar = function AppBar(props) {
  var _useProps = useProps(props),
    refThis = _useProps.refThis,
    refParallax = _useProps.refParallax,
    sideElementWidth = _useProps.sideElementWidth,
    wrapperStyle = _useProps.wrapperStyle,
    wrapperStickyStyle = _useProps.wrapperStickyStyle,
    wrapperStickedStyle = _useProps.wrapperStickedStyle,
    isParallaxVisible = _useProps.isParallaxVisible,
    alwaysShowAppBarTitle = _useProps.alwaysShowAppBarTitle,
    titleOpacity = _useProps.titleOpacity,
    parallaxOpacity = _useProps.parallaxOpacity,
    titleElement = _useProps.titleElement,
    titleAlignmentState = _useProps.titleAlignmentState,
    subTitleElement = _useProps.subTitleElement,
    leftButton = _useProps.leftButton,
    rightButton = _useProps.rightButton,
    enableScrollParallax = _useProps.enableScrollParallax,
    _useProps$parallaxWra = _useProps.parallaxWrapperComponent,
    ParallaxWrapper = _useProps$parallaxWra === void 0 ? ScrollParallaxWrapper : _useProps$parallaxWra,
    useScrollDownHide = _useProps.useScrollDownHide,
    expendScrollParallaxElement = _useProps.expendScrollParallaxElement,
    parentWidth = _useProps.parentWidth,
    handleResize = _useProps.handleResize,
    handleResizeSideWidth = _useProps.handleResizeSideWidth;
  var _useResizeDetector = useResizeDetector({
      handleWidth: true,
      onResize: handleResizeSideWidth
    }),
    refLeftWrapper = _useResizeDetector.ref;
  var _useResizeDetector2 = useResizeDetector({
      handleWidth: true,
      onResize: handleResizeSideWidth
    }),
    refRightWrapper = _useResizeDetector2.ref;
  useResizeDetector({
    handleWidth: true,
    refreshMode: "debounce",
    targetRef: refThis,
    onResize: handleResize
  });
  var subTitle = React.useMemo(function () {
    return subTitleElement ? jsx(SubTitle, {
      children: subTitleElement
    }) : null;
  }, [subTitleElement]);
  var leftElement = React.useMemo(function () {
    return jsx(LeftWrapper, {
      ref: refLeftWrapper,
      sideElementWidth: sideElementWidth,
      children: leftButton
    });
  }, [leftButton, sideElementWidth]);
  var rightElement = React.useMemo(function () {
    return jsx(RightWrapper, {
      ref: refRightWrapper,
      sideElementWidth: sideElementWidth,
      children: rightButton
    });
  }, [rightButton, sideElementWidth]);
  var parallaxElement = React.useMemo(function () {
    return enableScrollParallax && expendScrollParallaxElement ? jsx(ParallaxWrapper, {
      ref: refParallax,
      opacity: parallaxOpacity,
      children: expendScrollParallaxElement
    }) : null;
  }, [enableScrollParallax, expendScrollParallaxElement, parallaxOpacity, refParallax]);
  var appBarElement = React.useMemo(function () {
    var contents = jsxs(AppBarWrapper, {
      wrapperStyle: wrapperStyle,
      fixedWidth: parentWidth,
      children: [leftElement, jsx(CenterWrapper, {
        children: jsxs(TitleContainer, {
          alignment: titleAlignmentState,
          opacity: alwaysShowAppBarTitle ? 1 : titleOpacity,
          children: [jsx(MainTitle, {
            children: titleElement
          }), subTitle]
        })
      }), rightElement]
    });
    if (useScrollDownHide) {
      return jsx(DisplayControllerAboutScrollDirection, {
        overrideStyle: stickyWrapperStyle,
        overrideStickyStyle: wrapperStickyStyle,
        children: contents
      });
    }
    return jsx(StickyWrapper, {
      overrideStickyStyle: wrapperStickyStyle,
      children: contents
    });
  }, [alwaysShowAppBarTitle, leftElement, parentWidth, rightElement, subTitle, titleAlignmentState, titleElement, titleOpacity, useScrollDownHide, wrapperStickyStyle, wrapperStyle]);
  return jsxs(Wrapper, {
    ref: refThis,
    isSticky: enableScrollParallax,
    isParallaxVisible: isParallaxVisible,
    wrapperStickedStyle: wrapperStickedStyle,
    children: [appBarElement, parallaxElement]
  });
};

export { AppBar as default };
